import { DEMO_COPY, LOGOS } from '../../demo/copy'
import energie1 from '../media/branchen/energie-1.png'
import energie2 from '../media/branchen/energie-2.png'
import energie3 from '../media/branchen/energie-3.png'
import energie4 from '../media/branchen/energie-4.png'
import finanz1 from '../media/branchen/finanz-1.png'
import finanz2 from '../media/branchen/finanz-2.png'
import finanz3 from '../media/branchen/finanz-3.png'
import finanz4 from '../media/branchen/finanz-4.png'
import handel1 from '../media/branchen/handel-1.png'
import handel2 from '../media/branchen/handel-2.png'
import handel3 from '../media/branchen/handel-3.png'
import handel4 from '../media/branchen/handel-4.png'
import industrie1 from '../media/branchen/industrie-1.png'
import industrie2 from '../media/branchen/industrie-2.png'
import industrie3 from '../media/branchen/industrie-3.png'
import industrie4 from '../media/branchen/industrie-4.png'
import logistik1 from '../media/branchen/logistik-1.png'
import logistik2 from '../media/branchen/logistik-2.png'
import logistik3 from '../media/branchen/logistik-3.png'
import logistik4 from '../media/branchen/logistik-4.png'
import medien1 from '../media/branchen/medien-1.png'
import medien2 from '../media/branchen/medien-2.png'
import medien3 from '../media/branchen/medien-3.png'
import medien4 from '../media/branchen/medien-4.png'
import personal1 from '../media/branchen/personal-1.png'
import personal2 from '../media/branchen/personal-2.png'
import personal3 from '../media/branchen/personal-3.png'
import personal4 from '../media/branchen/personal-4.png'
import stadtwerke1 from '../media/branchen/stadtwerke-1.png'
import stadtwerke2 from '../media/branchen/stadtwerke-2.png'
import stadtwerke3 from '../media/branchen/stadtwerke-3.png'
import stadtwerke4 from '../media/branchen/stadtwerke-4.png'
import startups1 from '../media/branchen/startups-1.png'
import startups2 from '../media/branchen/startups-2.png'
import startups3 from '../media/branchen/startups-3.png'
import startups4 from '../media/branchen/startups-4.png'

/**
 * Produkt-Demo als Showcase. Inhalte wie im Demo-Deck 2026 (v12), die
 * Branchen-Personalisierung ebenfalls aus dem Deck: Logowand mit vier
 * Referenzen der Branche, dazu rückt die passende Fallstudie nach vorn.
 */

const DEFAULT_LOGOS = [
  LOGOS.lufthansa,
  LOGOS.beiersdorf,
  LOGOS.omr,
  LOGOS.frankfurtSchool,
  LOGOS.callways,
  LOGOS.mci,
  LOGOS.personaService
]

export const BRANCHES = [
  { id: 'allgemein', logos: DEFAULT_LOGOS, lead: null },
  {
    id: 'industrie',
    logos: [industrie1, industrie2, industrie3, industrie4],
    lead: 'beiersdorf'
  },
  { id: 'handel', logos: [handel1, handel2, handel3, handel4], lead: null },
  { id: 'finanz', logos: [finanz1, finanz2, finanz3, finanz4], lead: null },
  {
    id: 'energie',
    logos: [energie1, energie2, energie3, energie4],
    lead: null
  },
  {
    id: 'stadtwerke',
    logos: [stadtwerke1, stadtwerke2, stadtwerke3, stadtwerke4],
    lead: null
  },
  {
    id: 'logistik',
    logos: [logistik1, logistik2, logistik3, logistik4],
    lead: 'lufthansa'
  },
  {
    id: 'personal',
    logos: [personal1, personal2, personal3, personal4],
    lead: 'persona'
  },
  { id: 'medien', logos: [medien1, medien2, medien3, medien4], lead: 'omr' },
  {
    id: 'startups',
    logos: [startups1, startups2, startups3, startups4],
    lead: null
  }
]

const de = {
  ...DEMO_COPY.de,
  chapters: {
    ...DEMO_COPY.de.chapters,
    intro: 'Vorher wissen',
    problem: 'Unter der Oberfläche'
  },
  branches: {
    label: 'Branche',
    names: {
      allgemein: 'Allgemein',
      industrie: 'Industrie',
      handel: 'Handel',
      finanz: 'Finanzbranche',
      energie: 'Energie',
      stadtwerke: 'Stadtwerke',
      logistik: 'Logistik und Mobilität',
      personal: 'Personalunternehmen',
      medien: 'Medien',
      startups: 'Start- und Scale-ups'
    },
    trust: 'Vertraut von HR-Teams wie',
    trustIn: 'Vertraut in der Branche'
  },
  show: {
    kicker: 'Software für fundierte Vorauswahl',
    title: 'Vorher wissen, mit wem das Gespräch lohnt.',
    stats: [
      { value: '30 %', label: 'weniger Fehlentscheidungen' },
      { value: '70 %', label: 'weniger Aufwand in der Vorauswahl' },
      { value: '9/10', label: 'Bewerbende bevorzugen Aivy' }
    ],
    cv: ['Ein Lebenslauf zeigt,', 'wo jemand war.', 'Nicht, was jemand kann.'],
    dive: 'Darunter liegt, worauf es ankommt.',
    order: 'Aus Bauchgefühl wird Klarheit.',
    proofs: ['70 %', '96 %', '30 %'],
    stepsTitle: 'Drei Schritte. Ein klares Bild.',
    analyseTitle: 'Die Messlatte steht, bevor die erste Bewerbung kommt.',
    analyseVideo: 'Anforderungsanalyse im Aivy-Dashboard',
    games: [
      {
        name: 'Codeknacker',
        dim: 'Merkfähigkeit',
        group: 'Fähigkeiten',
        time: '3 Min.'
      },
      {
        name: 'Hochstapler',
        dim: 'Problemlösefähigkeit',
        group: 'Fähigkeiten',
        time: '3 Min.'
      },
      {
        name: 'Gefühlschaos',
        dim: 'Emotionswahrnehmung',
        group: 'Fähigkeiten',
        time: '2 Min.'
      },
      {
        name: 'Selbsterkenntnis',
        dim: 'Big Five',
        group: 'Persönlichkeit',
        time: '2 Min.'
      },
      {
        name: 'Tätigkeitsvielfalt',
        dim: 'RIASEC',
        group: 'Interessen',
        time: '2 Min.'
      }
    ],
    gameStats: [
      { value: '9/10', label: 'bevorzugen Aivy' },
      { value: '94 %', label: 'Abschlussrate' },
      { value: '12', label: 'validierte Verfahren' }
    ],
    realClips: 'Echte Aufnahmen aus der Aivy-App',
    scoreTitle: 'Eine Zahl.',
    scoreSub: 'Und hinter jeder Zahl ein Grund.',
    streamTitle: 'Alle werden eingeladen. Die Passenden ziehen weiter.',
    gate: 'Aivy',
    sphereTitle: 'Wissenschaftlich entwickelt, in der Praxis bewährt.',
    scienceStats: [
      { value: '1.000.000+', label: 'Testungen durchgeführt' },
      { value: '200+', label: 'Unternehmen im Einsatz' },
      { value: '5+', label: 'Jahre in echten Prozessen' }
    ],
    casesHint: 'Scroll dreht das Karussell',
    closeTitle: 'Chancengeber statt nur Arbeitgeber.'
  }
}

const en = {
  ...DEMO_COPY.en,
  chapters: {
    ...DEMO_COPY.en.chapters,
    intro: 'Know in advance',
    problem: 'Below the surface'
  },
  branches: {
    label: 'Industry',
    names: {
      allgemein: 'General',
      industrie: 'Industry',
      handel: 'Retail',
      finanz: 'Financial services',
      energie: 'Energy',
      stadtwerke: 'Municipal utilities',
      logistik: 'Logistics and mobility',
      personal: 'Staffing',
      medien: 'Media',
      startups: 'Start-ups and scale-ups'
    },
    trust: 'Trusted by HR teams like',
    trustIn: 'Trusted in the industry'
  },
  show: {
    kicker: 'Software for evidence-based pre-selection',
    title: 'Know in advance who is worth the interview.',
    stats: [
      { value: '30 %', label: 'fewer wrong decisions' },
      { value: '70 %', label: 'less effort in pre-selection' },
      { value: '9/10', label: 'candidates prefer Aivy' }
    ],
    cv: ['A CV shows', 'where someone has been.', 'Not what they can do.'],
    dive: 'What matters lies underneath.',
    order: 'Gut feeling turns into clarity.',
    proofs: ['70 %', '96 %', '30 %'],
    stepsTitle: 'Three steps. One clear picture.',
    analyseTitle: 'The bar is set before the first application arrives.',
    analyseVideo: 'Requirements analysis in the Aivy dashboard',
    games: [
      { name: 'Codeknacker', dim: 'Memory', group: 'Abilities', time: '3 min' },
      {
        name: 'Hochstapler',
        dim: 'Problem solving',
        group: 'Abilities',
        time: '3 min'
      },
      {
        name: 'Gefühlschaos',
        dim: 'Emotion perception',
        group: 'Abilities',
        time: '2 min'
      },
      {
        name: 'Selbsterkenntnis',
        dim: 'Big Five',
        group: 'Personality',
        time: '2 min'
      },
      {
        name: 'Tätigkeitsvielfalt',
        dim: 'RIASEC',
        group: 'Interests',
        time: '2 min'
      }
    ],
    gameStats: [
      { value: '9/10', label: 'prefer Aivy' },
      { value: '94 %', label: 'completion rate' },
      { value: '12', label: 'validated assessments' }
    ],
    realClips: 'Real recordings from the Aivy app',
    scoreTitle: 'One number.',
    scoreSub: 'And a reason behind every number.',
    streamTitle: 'Everyone gets invited. The right people move on.',
    gate: 'Aivy',
    sphereTitle: 'Scientifically developed, proven in practice.',
    scienceStats: [
      { value: '1,000,000+', label: 'assessments completed' },
      { value: '200+', label: 'companies using Aivy' },
      { value: '5+', label: 'years in real hiring processes' }
    ],
    casesHint: 'Scrolling turns the carousel',
    closeTitle: 'An opportunity giver, not just an employer.'
  }
}

export const SHOW_DEMO_COPY = { de, en }
